import React from "react";

import styles from './styles.module.scss';
import FordKPIsCardFilters from "modules/reporting/fordReports/kpis/filters";
import FordKPIsSections from "modules/reporting/fordReports/kpis/sections";

const FordKPIsCard = () => {
  return (
    <section className={styles.kpisWrapper}>
      {/*<FordKPIsCardFilters />*/}
      <FordKPIsSections />
    </section>
  );
};

export default React.memo(FordKPIsCard);
